import React from 'react'
import './Footer.css'
import { FaChevronRight, FaFacebookF, FaLinkedinIn } from 'react-icons/fa'
import footerlogo from '../../assets/img/white_logo.svg'
import blog1 from '../../assets/img/blog1.webp'
import blog2 from '../../assets/img/blog2.webp'
import { Link } from 'react-router-dom'
import { FaXTwitter } from 'react-icons/fa6'
import { useNavigate } from 'react-router-dom';

function Footer() {

   const navigate = useNavigate();
   const currentYear = new Date().getFullYear();

   const handleClick =()=>{
    window.scrollTo(0,0)
  }

   const blogdate = [
      {
      img:blog1,
      title: "Custom Web Design Solutions in Qatar: Tailored for Success",
      path: "/custom-web-design-solutions-in-qatar-tailored-for-success"   
      },
      {
         img:blog2,
         title: "How Cloud Computing Is Transforming Businesses In Qatar",
         path: "/how-cloud-computing-is-transforming-businesses-in-qatar"
      }
   ]

  return (
    <footer>
       <div className='container'>
           <div className='ftr-abt'>
              <img src={footerlogo} alt='360Bytes Logo' width={150} height={65} loading="lazy"/>
              <p>We at 360 Bytes follow a highly streamlined and agile development process to ensure fast paced execution and speedy delivery time without compromising on quality standards.</p>
               <button className='btn-main' onClick={() => navigate('/contact')}><span>Contact Us</span> <FaChevronRight /></button>
               <h5>ON SOCIAL NETWORKS</h5> 
               <ul>
                  <li><a href='https://www.facebook.com/360bytes/' target='_blank'><FaFacebookF  /></a></li>
                  <li><a href='https://x.com/360_bytes' target='_blank'><FaXTwitter  /></a></li>
                  <li><a href='https://www.linkedin.com/company/360bytes' target='_blank'> <FaLinkedinIn  /> </a></li>
               </ul>
           </div>
           <div className='ftr-ser'>
              <h4>Services</h4>
              <ul>
                <li><Link to='/web-application-development' onClick={handleClick}>Website Design & Developemnt </Link></li>
                <li><Link to='/mobile-application-development' onClick={handleClick}>Mobile Application Development </Link></li>
                <li><Link to='/custom-software-development' onClick={handleClick}>Custom Software Development  </Link></li>
                <li><Link to='/e-commerce-development' onClick={handleClick}>E-Commerce Development  </Link></li>
                <li><Link to='/saas-development' onClick={handleClick}>SaaS Development</Link></li>
                <li><Link to='/web-application-development' onClick={handleClick}>Digital Transformation</Link></li>
              </ul>
           </div>
           <div className='ftr-blg'>
             <h4>Blogs</h4>
              <ul>
               {
                  blogdate.map((Footer,index)=>(
                     <li key={index}>
                     <Link to={Footer.path}  onClick={handleClick}>
                        <div className='ftrblg-img'><img src={Footer.img} alt={Footer.title} width={300} height={200} loading="lazy"/></div>
                        <div className='ftrblg-txt'>{Footer.title}</div> 
                     </Link>
                     </li>  

                  ))
               }

              </ul> 
           </div>
           <div className='ftr-nav'>
             <ul>
               <li><Link to='/' onClick={handleClick}>Home</Link></li> 
               <li><Link to='/about' onClick={handleClick}>About us</Link></li>
               <li><Link to='/Service' onClick={handleClick}>Services</Link></li>
               <li><Link to='/product' onClick={handleClick}>Our Product</Link></li>
               <li><Link to='/project' onClick={handleClick}>Our Projects</Link></li>
               {/* <li><Link onClick={handleClick}>Blogs</Link></li> */}
               <li><Link to='/clients' onClick={handleClick}>Clients</Link></li>
               <li><Link to='https://in.linkedin.com/company/360bytes' target='_blank'>Careers </Link></li>
               <li><Link to='/contact' onClick={handleClick}>Contact Us</Link></li>  
             </ul>
             <p>Copyright {currentYear} © 360Bytes. All Rights Reserved.</p> 
           </div> 
       </div>

    </footer>
  )
}

export default Footer
